import { render, staticRenderFns } from "./FabricStatistics.vue?vue&type=template&id=b45c08e4&scoped=true&"
import script from "./FabricStatistics.vue?vue&type=script&lang=js&"
export * from "./FabricStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FabricStatistics.vue?vue&type=style&index=0&id=b45c08e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45c08e4",
  null
  
)

export default component.exports